<template>
  <b-row no-gutters class="sidebar-siprem">

    <b-col >
      <b-row class="mt-2">
        <b-col></b-col>
      </b-row>

      <b-row v-if="catalogCobro"  class="mt-4">
        <b-col>
          <b-button  block class="btn-cat-sidebar" v-b-toggle.collapse-caja ><b-icon icon="cash"/> Recaudación</b-button>
          <b-collapse id="collapse-caja" accordion="sidebar-accordion">
            <b-row>
              <b-col class="innerTree">
                <router-link :to="municipio+'/cobro'">
                  <TreeCollapse/>
                </router-link>
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>

      <b-row v-if="catalogFormas"  class="mt-4">
        <b-col>
          <b-button block class="btn-cat-sidebar" v-b-toggle.collapse-formas ><b-icon icon="files"/> Trámites</b-button>
          <b-collapse id="collapse-formas" accordion="sidebar-accordion">
            <b-row>
              <b-col class="innerTree">
                <b-row>
                  <b-col>
                    <router-link :to="municipio+'/formas'">
                      <b-button block class="btn-cat-sidebar"><b-icon  font-scale=".9" icon="search"/> Consultar</b-button>
                    </router-link>
                  </b-col> 
                </b-row>     
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>

      <b-row v-if="catalogReportes" class="mt-4">
        <b-col>
          <b-button block class="btn-cat-sidebar" v-b-toggle.collapse-reportes ><b-icon icon="graph-up"/> Reportes</b-button>
          <b-collapse id="collapse-reportes" accordion="sidebar-accordion">
            <b-row>
              <b-col class="innerTree">
                <b-row>
                  <b-col>
                    <router-link :to="municipio+'/reportes'">
                      <b-button block class="btn-cat-sidebar"><b-icon font-scale=".9" icon="search"/> Consultar</b-button>
                    </router-link>
                  </b-col> 
                </b-row>                
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>

      
      <b-row v-if="catalogoPadrones"  class="mt-4">
        <b-col>
          <b-button block class="btn-cat-sidebar" v-b-toggle.collapse-padron ><b-icon icon="person-lines-fill"/> Padrones</b-button>
          <b-collapse id="collapse-padron" accordion="sidebar-accordion">
            <b-row>
              <b-col class="innerTree">
                <b-row>
                  <b-col cols="12">
                    <router-link :to="municipio+'/padrones'">
                      <b-button block size="sm" class="btn-cat-sidebar mt-1" @click="makeCommit('updateOpcionFuncionPadron', 0)">
                        <b-icon variant="light" icon="people-fill"/> Buscar Contribuyente
                      </b-button>
                    </router-link>
                  </b-col>
                  <b-col cols="12">
                    <router-link :to="municipio+'/padrones'">
                      <b-button block size="sm" class="btn-cat-sidebar mt-1" @click="makeCommit('updateOpcionFuncionPadron', 1)">
                        <b-icon variant="light" icon="person-plus-fill"/> Agregar Contribuyente
                      </b-button>
                    </router-link>
                  </b-col>
                  <b-col cols="12" v-if="municipio.includes('demo') || municipio.includes('aguaixta') || municipio.includes('aguahuix') ||  municipio.includes('aguachalco')">
                    <router-link :to="municipio+'/padrones'">
                      <b-button block size="sm" class="btn-cat-sidebar mt-1" @click="makeCommit('updateOpcionFuncionPadron', 2)">
                        <b-icon variant="light" icon="card-checklist"/> Carga de Lecturas
                      </b-button>
                    </router-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>
      
      <b-row v-if="catalogoAdmin!=null"  class="mt-4">
        <b-col>
          <b-button block class="btn-cat-sidebar" v-b-toggle.collapse-config ><b-icon icon="person-lines-fill"/> Configuración</b-button>
          <b-collapse id="collapse-config" accordion="sidebar-accordion">
            <b-row>
              <b-col class="innerTree">
                <b-row>
                  <b-col cols="12" v-if="catalogoAdmin.editaCatalogosCatastrales">
                    <router-link :to="municipio+'/catalogoscat'">
                      <b-button block size="sm" class="btn-cat-sidebar mt-1" >
                        <b-icon variant="light" icon="list-fill"/> Catalogos Catastrales
                      </b-button>
                    </router-link>
                  </b-col>
                  
                </b-row>
              </b-col>
            </b-row>
          </b-collapse>
        </b-col>
      </b-row>

      <b-row class="mb-5">
        <b-col>

        </b-col>
      </b-row>

    </b-col>
  </b-row>
</template>

<script>
import { isTokenValid } from '@/auth-tools';
import { mapState} from 'vuex';
import TreeCollapse from '@/components/cobro/TreeCollapse.vue'

export default {
  computed: {
    ...mapState({
      catalogoPadrones: state => state.padrones.catalogoPadrones,
      catalogFormas: state => state.formas.catalogFormas,
      catalogCobro: state => state.cobro.catalogCobro,
      catalogReportes: state => state.reportes.catalogReportes,
      catalogoAdmin: state => state.admin.catalogoAdmin,
    }),
  },
  components:{
    TreeCollapse
  },
  data(){
    return{
      municipio: "/"+location.pathname.split("/", 2).toString().replace(",", "")
    }
  },
  methods: {
    isTokenValidated (){
      var dateToken = this.$store.state.login.dateToken;
      var token = this.$store.state.login.token;
      return isTokenValid(token, dateToken);
    },
    makeCommit(commit, value){
      this.$store.commit(commit, value);
      if(window.matchMedia("(max-width: 768px)").matches){
        this.$store.commit("updateIsShowSideCobro", false);
        
      }
      window.scrollTo(0, 0);
    }
  }
}
</script>

<style>
.bg-toggle{
        background-color: white;
}
.btn-cat-sidebar{
  text-align:left; 
  background-color:#0c0f3a; 
  border:none; 
  border-radius: 0%;
  outline:0;
}
.btn-cat-sidebar:focus{
  box-shadow: none ;
}
.sidebar-siprem{
    min-height: 100vh; 
    background-color:#0c0f3a;
    width: 100vw ;
    /* margin-left: -15px; */
    box-shadow: 7px 20px 15px 5px #A4A3A3;
    /*position: absolute;*/
    /*z-index: 1002;*/
  }
.innerTree{
  padding-left:30px;
}

</style>